import * as React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Tooltip } from '@mui/material';
import moment from 'moment';

interface DatePickerDDMMYYProps {
  label?: string;
  value: string; 
  onChange: (value: string) => void; 
  placeholder?: string;
  minDate?: string; 
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  className?: string;
  sx?: any;
  tooltip?: string; 
}

export default function DatePickerDDMMYY({
  label,
  value,
  onChange,
  placeholder = 'dd/mm/yy',
  minDate,
  disabled = false,
  required = false,
  error = false,
  helperText,
  size = 'small',
  fullWidth = false,
  className,
  sx,
  tooltip,
}: DatePickerDDMMYYProps) {
  const momentValue = value ? moment(value, 'YYYY-MM-DD') : null;

  const handleChange = (newValue: moment.Moment | null) => {
    if (newValue && newValue.isValid()) {
      onChange(newValue.format('YYYY-MM-DD'));
    } else {
      onChange('');
    }
  };

  const minDateMoment = minDate ? moment(minDate, 'YYYY-MM-DD') : undefined;

  const datePicker = (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        label={label}
        value={momentValue}
        onChange={handleChange}
        format="DD/MM/YY"
        minDate={minDateMoment}
        disabled={disabled}
        slotProps={{
          textField: {
            placeholder,
            required,
            error,
            helperText,
            size,
            fullWidth,
            className,
            sx: {
              '& .MuiInputBase-input': { 
                padding: size === 'small' ? '10px 14px' : '16.5px 14px',
                fontSize: '0.875rem',
              },
              '& .MuiInputBase-root': {
                height: size === 'small' ? '36px' : 'auto',
                borderRadius: '5px',
              },
              'fieldset.MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(0, 0, 0, 0.23)',
                borderRadius: '5px',
              },
              '&:hover fieldset.MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(0, 0, 0, 0.87)',
              },
              '.Mui-focused fieldset.MuiOutlinedInput-notchedOutline': {
                borderColor: '#3B82F6',
                borderWidth: '1px',
              },
              ...sx,
            },
          },
        }}
        sx={{
          width: fullWidth ? '100%' : 'auto',
        }}
      />
    </LocalizationProvider>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow placement="top">
        <span style={{ display: 'inline-block', width: fullWidth ? '100%' : 'auto' }}>
          {datePicker}
        </span>
      </Tooltip>
    );
  }

  return datePicker;
}

